module.exports = __webpack_public_path__ + "img/logo364x364.3a805707.png";